import { View } from 'react-native'
import { colors } from '@ui/colors'
import useRWD from '@ui/theme/useRWD'
import Skeleton from '@ui/elements/Skeleton'

const Loader = () => {
  const { tiles } = useRWD()
  const height = tiles.blur.height

  return (
    <Skeleton
      className="flex-1"
      style={{ height, backgroundColor: colors.gray[75], borderRadius: 32 }}
    />
  )
}

const Row = ({ children }: { children: React.ReactNode }) => (
  <View className="w-full flex-row gap-8">{children}</View>
)

export default function IntroTilesLoading() {
  return (
    <>
      <View className="gap-8 p-8 pt-0">
        <Row>
          <Loader />
        </Row>
        <Row>
          <Loader />
          <Loader />
        </Row>
        <Row>
          <Loader />
          <Loader />
        </Row>
        <Row>
          <Loader />
        </Row>
      </View>
    </>
  )
}
